import { Link } from "react-router-dom";
import { formatInteger } from "../../services/common/NumberUtil";

export default function ClubRow({ club }) {
  return (
    <Link
      to={`/clubs/${club.id}`}
      className="d-flex  w-100 py-1 text-decoration-none text-dark hover-bg-white"
    >
      <div className="flex-grow-1 pe-2 ps-1">{club.name}</div>
      <div className="d-flex justify-content-end  pe-2">{club.department}</div>
      <div className="d-flex justify-content-end text-muted">
        {formatInteger(club.stats?.athletes ?? 0)}
      </div>
    </Link>
  );
}
